import { ReferenceBusinessId, ReferenceContactId } from "@sp-crm/core";
import type { AppRouter } from "@sp-crm/server/rpc";
import { skipToken } from "@tanstack/react-query";
import type { inferProcedureOutput } from "@trpc/server";
import { trpc } from "components/rpc/trpc";
import { SpMultiSelectOption } from "components/ui/sp-multi-select";

type TrpcOptionsProxy = ReturnType<typeof trpc.useTRPC>;

type AttendeeCandidate = inferProcedureOutput<
    AppRouter["touchpoint"]["listAttendeeCandidates"]
>[number];

export const attendeeCandidatesQueryOptions = (
    trpcClient: TrpcOptionsProxy,
    businessId: ReferenceBusinessId | null,
) =>
    businessId
        ? trpcClient.touchpoint.listAttendeeCandidates.queryOptions({ businessId })
        : trpcClient.touchpoint.listAttendeeCandidates.queryOptions(skipToken);

export const attendeeCandidateOptions = (
    candidates: AttendeeCandidate[] | undefined,
): SpMultiSelectOption<ReferenceContactId>[] =>
    (candidates ?? [])
        .map(candidate => ({ id: candidate.id, label: candidate.name }))
        .sort((a, b) => a.label.localeCompare(b.label));
